import { z } from 'zod/v4-mini'

export const statisticsTabSchema = z.enum([
    'project_hours',
    'hours_in_selection',
    'compare_worked_hours_to_wtm',
])
export type StatisticsTabSchema = z.infer<typeof statisticsTabSchema>
